import { fork, takeLatest } from 'redux-saga/effects';

import { ACTIVATE_FLEXI12_DASHBOARD } from './Dashboard.actions';
import { putAndWaitHandleAllAPIError } from '../../api/API.sagas';
import {
    API_GET_CUSTOMER_STATE,
    API_GET_APPLICATION,
    API_GET_ACCOUNTS
} from '../../api/lendingAPI/LendingAPI.actions';
import { createWorkersForPage } from '../pageStructure/routerWorkers/PageWorkerFactory.sagas';

export const FLEXI_12_URL = '/';

export const dashboardSagaWorkers = createWorkersForPage({
    page: 'FLEXI12_DASHBOARD',
    isInPageLocation: (location) => location.pathname === FLEXI_12_URL,
    createPageFlowWorkers: () => [fork(dashboardPageWorker)]
});

function* dashboardPageWorker() {
    yield takeLatest(ACTIVATE_FLEXI12_DASHBOARD, function* () {
        yield putAndWaitHandleAllAPIError([
            { type: API_GET_APPLICATION },
            { type: API_GET_ACCOUNTS },
            { type: API_GET_CUSTOMER_STATE }
        ]);
    });
}
